@if (showHeadline()) {
    <div
        class="add--header"
        data-testid="t-certification-div-1752672977568-3"
    >
        <div
            class="col"
            data-testid="t-certification-div-1752672977568-1"
        >
            <span
                class="h5"
                data-testid="t-certification-span-1752672977568-1"
                >{{ 'mws.certifications' | i18n }}:</span
            >
        </div>
        @if (showButtons() && possibleCertifications && possibleCertifications.length > 0 && supplierService.supplierBasedata.updatable) {
            <div
                class="col-auto text-end"
                data-testid="t-certification-div-1752672977568-2"
            >
                <a
                    class="btn btn-sm btn-primary action--btn"
                    (click)="openCertificateModal()"
                    data-testid="t-certification-a-1752672977568-1"
                    ><i
                        class="oc-plus"
                        data-testid="t-certification-i-1752672977568-1"
                    ></i
                ></a>
            </div>
        }
    </div>
}

<div
    class="table-responsive table-oc-responsive table-scrollable table-datetime"
    id="certification_supplier_table"
    data-testid="t-certification-div-1752672977568-4"
>
    <table
        cdk-table
        [dataSource]="supplierService.supplierCertifications"
        class="table"
        data-testid="t-certification-table-1752672977568-1"
    >
        @if (showValid()) {
            <ng-container cdkColumnDef="validFrom">
                <th
                    style="width: 1%"
                    cdk-header-cell
                    *cdkHeaderCellDef
                    data-testid="t-certification-th-1752672977568-1"
                >
                    {{ 'mws.datefrom' | i18n }}
                </th>
                <td
                    cdk-cell
                    *cdkCellDef="let element"
                    data-testid="t-certification-td-1752672977568-1"
                >
                    {{ element.validFrom | ocDatepipe: 'L' }}
                </td>
            </ng-container>
        }
        @if (showValid()) {
            <ng-container cdkColumnDef="validTill">
                <th
                    style="width: 1%"
                    cdk-header-cell
                    *cdkHeaderCellDef
                    data-testid="t-certification-th-1752672977568-2"
                >
                    {{ 'mws.datetill' | i18n }}
                </th>
                <td
                    cdk-cell
                    *cdkCellDef="let element"
                    data-testid="t-certification-td-1752672977568-2"
                >
                    {{ element.validTill | ocDatepipe: 'L' }}
                </td>
            </ng-container>
        }
        <ng-container cdkColumnDef="name">
            <th
                cdk-header-cell
                *cdkHeaderCellDef
                data-testid="t-certification-th-1752672977568-3"
            >
                {{ 'mws.certificate' | i18n }}
            </th>
            <td
                cdk-cell
                *cdkCellDef="let element"
                data-testid="t-certification-td-1752672977568-3"
            >
                {{ element.certificate.name }}
            </td>
        </ng-container>
        <ng-container cdkColumnDef="description">
            <th
                cdk-header-cell
                *cdkHeaderCellDef
                data-testid="t-certification-th-1752672977568-4"
            >
                {{ 'mws.description' | i18n }}
            </th>
            <td
                cdk-cell
                *cdkCellDef="let element"
                data-testid="t-certification-td-1752672977568-4"
            >
                {{ element.certificate.descr }}
            </td>
        </ng-container>
        <ng-container cdkColumnDef="image">
            <th
                cdk-header-cell
                *cdkHeaderCellDef
                data-testid="t-certification-th-1752672977568-5"
            ></th>
            <td
                cdk-cell
                *cdkCellDef="let element"
                data-testid="t-certification-td-1752672977568-5"
            >
                <!--                <img loading="lazy" class="cert&#45;&#45;image" *ngIf="elementRef.certificate.id" src="{{environmentService.getURL(environmentService.appSettings.fakeServer)}}/image?imageId={{elementRef.certificate.id}}&language={{environmentService.appSettings.locale}}" alt="">-->
            </td>
        </ng-container>
        @if (showButtons()) {
            <ng-container cdkColumnDef="buttons">
                <th
                    cdk-header-cell
                    *cdkHeaderCellDef
                    data-testid="t-certification-th-1752672977568-6"
                ></th>
                <td
                    cdk-cell
                    *cdkCellDef="let element"
                    align="right"
                    data-testid="t-certification-td-1752672977568-6"
                >
                    @if (supplierService.supplierBasedata.updatable) {
                        <a
                            class="btn btn-sm action--btn btn-primary"
                            [attr.aria-label]="'mws.edit' | i18n"
                            (click)="openEditCertificateModal(element)"
                            data-testid="t-certification-a-1752672977568-2"
                            ><i
                                class="oc-general-edit"
                                data-testid="t-certification-i-1752672977568-2"
                            ></i
                        ></a>
                    }
                    @if (supplierService.supplierBasedata.updatable) {
                        <a
                            class="btn btn-sm btn-danger action--btn"
                            [attr.aria-label]="'button.delete' | i18n"
                            (click)="openArchiveModal(element.id)"
                            data-testid="t-certification-a-1752672977568-3"
                            ><i
                                class="oc-trash-can"
                                data-testid="t-certification-i-1752672977568-3"
                            ></i
                        ></a>
                    }
                </td>
            </ng-container>
        }
        <tr
            cdk-header-row
            *cdkHeaderRowDef="displayedCertificationsColumns"
            data-testid="t-certification-tr-1752672977568-1"
        ></tr>
        <tr
            cdk-row
            *cdkRowDef="let row; columns: displayedCertificationsColumns"
            data-testid="t-certification-tr-1752672977568-2"
        ></tr>
    </table>
</div>

<ng-template
    #certificationModal
    let-c="close"
    let-d="dismiss"
>
    <form
        [formGroup]="certificationForm"
        novaliddate
        data-testid="t-certification-form-1752672977568-1"
    >
        <div
            class="modal-header"
            data-testid="t-certification-div-1752672977568-5"
        >
            <button
                type="button"
                id="deliverycondition-cancel"
                [attr.aria-label]="'button.discard' | i18n"
                class="btn btn-close"
                (click)="d('Close click')"
                data-testid="t-certification-button-1752672977568-1"
            >
                <i
                    class="oc-general-cancel"
                    data-testid="t-certification-i-1752672977568-4"
                ></i>
            </button>
            <span
                class="h5 modal-title"
                data-testid="t-certification-span-1752672977568-2"
                >{{ 'mws.certificationadd' | i18n }}</span
            >
        </div>

        <div
            class="modal-body"
            data-testid="t-certification-div-1752672977568-11"
        >
            <span
                class="h5"
                data-testid="t-certification-span-1752672977568-3"
                >{{ 'mws.certificate' | i18n }}:</span
            >

            <div
                class="select-wrapper"
                data-testid="t-certification-div-1752672977568-6"
            >
                <label
                    class="form-label"
                    data-testid="t-certification-label-1752672977568-1"
                    >{{ 'mws.certificate' | i18n }}:</label
                >
                <select
                    formControlName="certificate"
                    class="form-select"
                    data-testid="t-certification-select-1752672977568-1"
                >
                    @for (certificate of possibleCertifications; track certificate) {
                        <option
                            [ngValue]="certificate.id"
                            data-testid="t-certification-option-1752672977568-1"
                        >
                            {{ certificate.name }} - {{ certificate.descr }}
                        </option>
                    }
                </select>
            </div>

            <hr data-testid="t-certification-hr-1752672977568-1" />
            <div
                class="add--header"
                data-testid="t-certification-div-1752672977568-7"
            >
                <span
                    class="h5"
                    data-testid="t-certification-span-1752672977568-4"
                >
                    {{ 'mws.validityperiod' | i18n }}
                </span>
            </div>
            <div
                class="row g-3"
                data-testid="t-certification-div-1752672977568-10"
            >
                <div
                    class="form-group col-6"
                    data-testid="t-certification-div-1752672977568-8"
                >
                    <app-date-picker
                        [title]="'mws.datefrom' | i18n"
                        [locale]="environmentService.appSettings.locale.split('_')[0]"
                        [fC]="validFromControl"
                        [schema]="'supplierCertification'"
                        [propertyName]="'validFrom'"
                        [options]="validFromPickerOptions"
                        [showClearDate]="false"
                        (dateChange)="onDateFromChanged($event)"
                        data-testid="t-certification-app-date-picker-1752672977568-1"
                    ></app-date-picker>
                </div>

                <div
                    class="form-group col-6"
                    data-testid="t-certification-div-1752672977568-9"
                >
                    <app-date-picker
                        [title]="'mws.datetill' | i18n"
                        [locale]="environmentService.appSettings.locale.split('_')[0]"
                        [fC]="validTillControl"
                        [schema]="'supplierCertification'"
                        [propertyName]="'validTill'"
                        [options]="validTillPickerOptions"
                        [showClearDate]="true"
                        (dateChange)="onDateTillChanged($event)"
                        [disabled]="!validFromControl.value || !validFromControl.value.singleDate"
                        data-testid="t-certification-app-date-picker-1752672977568-2"
                    ></app-date-picker>
                </div>
            </div>
        </div>
        <div
            class="modal-footer"
            data-testid="t-certification-div-1752672977568-13"
        >
            <div
                class="button-wrapper"
                data-testid="t-certification-div-1752672977568-12"
            >
                <button
                    type="button"
                    id="deliverycondition-success"
                    [attr.aria-label]="'button.check' | i18n"
                    class="btn btn-success"
                    (click)="saveCertificate(); c('Close click')"
                    [disabled]="!certificationForm.get('changed').touched"
                    data-testid="t-certification-button-1752672977568-2"
                >
                    <i
                        class="oc-general-check"
                        data-testid="t-certification-i-1752672977568-5"
                    ></i>
                </button>
            </div>
        </div>
    </form>
</ng-template>

<ng-template
    #archiveElementCertificate
    let-c="close"
    let-d="dismiss"
>
    <div
        class="modal-header"
        data-testid="t-certification-div-1752672977568-14"
    >
        <button
            type="button"
            id="close-archive-element-button-deliveryterms-button"
            [attr.aria-label]="'button.discard' | i18n"
            class="btn btn-close"
            (click)="d('Close click')"
            data-testid="t-certification-button-1752672977568-3"
        >
            <i
                class="oc-general-cancel"
                data-testid="t-certification-i-1752672977568-6"
            ></i>
        </button>
        <span
            class="h5 modal-title"
            data-testid="t-certification-span-1752672977568-5"
            >{{ 'mws.archivesuppliercertificationheadline' | i18n }}</span
        >
    </div>

    <div
        class="modal-body"
        [innerHTML]="'mws.archivesuppliercertificationtext' | i18n"
        data-testid="t-certification-div-1752672977568-15"
    ></div>

    <div
        class="modal-footer"
        data-testid="t-certification-div-1752672977568-17"
    >
        <div
            class="button-wrapper"
            data-testid="t-certification-div-1752672977568-16"
        >
            <button
                type="button"
                id="open-archive-element-button-deliveryterms-button"
                [attr.aria-label]="'button.check' | i18n"
                class="btn btn-success"
                (click)="archiveCertificate(); c('Close click')"
                data-testid="t-certification-button-1752672977568-4"
            >
                <i
                    class="oc-general-check"
                    data-testid="t-certification-i-1752672977568-7"
                ></i>
            </button>
        </div>
    </div>
</ng-template>
